import { differenceInYears } from 'date-fns';
export function isMinor(birthDate, currentDate = new Date()) {
    return differenceInYears(currentDate, birthDate) < 18.0;
}
//# sourceMappingURL=age.js.map